import { ActionType } from '../constants/ActionTypes'
import config from '../constants/Configs'
import WalletType from '../constants/Enums/WalletType'
import { Auth } from '../services/Auth'

function getBalances(payload, state) {
    const { data = {}, isNewBonuses } = payload;
    const {availableBalance, ...rest} = data;
    if (isNewBonuses) {
        return {
            ...rest,
            combinedBalance: availableBalance,
        }
    }
    return config.NEW_PLAT ? {
        ...data,
        availableBalance: data?.realBalance,
        bonusBalance: data?.bonusBalance,
        balances: state.playerData?.accountBalance?.balances.some(purse => purse.typeId === WalletType.Bonus) ?
            state.playerData?.accountBalance?.balances?.map(purse => {
                if (purse.typeId === WalletType.Bonus) {
                    purse.balance = data?.bonusBalance
                }
                return purse
            }) : [...state.playerData?.accountBalance?.balances || [], {
                typeId: WalletType.Bonus,
                balance: data?.bonusBalance
            }]
    } : { availableBalance: data }
}

function getWallets(payload) {
    const { data, isNewBonuses } = payload;
    return isNewBonuses ? {
        ...data,
        withdrawalBalance: data.withdrawable,
        balances: [
            ...(data.hasOwnProperty('rollover') ? [{
                balance: data.rollover,
                currencyId: data.currencyId,
                typeId: WalletType.Rollover
            }] : []),

            ...(data.hasOwnProperty('unused') ? [{
                balance: data.unused,
                currencyId: data.currencyId,
                typeId: WalletType.Unused
            }] : []),

            ...(data.hasOwnProperty('used') ? [{
                balance: data.used,
                currencyId: data.currencyId,
                typeId: WalletType.Used
            }] : []),
            ...(data.hasOwnProperty('bonusBalance') ? [{
                balance: data.bonusBalance,
                currencyId: data.currencyId,
                typeId: WalletType.Bonus
            }] : []),
        ]
    } : {
        ...data
    }
}

export default function userReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.TOGGLE_SIDEBAR_MENU:
            return {
                ...state,
                isSidebarOpen: action.payload
            }
        case ActionType.TOGGLE_MOBILE_NAV_MENU:
            return {
                ...state,
                isMobileNavMenuOpen: action.payload
            }
        case ActionType.LOGIN_USER_BEGIN:
            return {
                ...state,
                isLoading: true,
                isLoggedIn: false,
                refreshTokenWaiting: false,
                isUploading: false,
                documentSuccess: null,
                error: null
            }
        case ActionType.RESET_CALLBACK_STATUS:
            return {
                ...state,
                error: null,
                success: null,
                profileSuccess: null,
                profileError: {
                    message: null
                },
                registrationError: {
                    message: null
                }
            }
        case ActionType.RESET_SUCCESS_MESSAGE:
            return {
                ...state,
                success: null,
                profileSuccess: null
            }
        case ActionType.GET_LOCATION_SUCCESS:
            return {
                ...state,
                location: action.payload
            }
        case ActionType.OPEN_ONE_CLICK_POPUP:
            return {
                ...state,
                oneClickLogin: action.payload
            }
        case ActionType.CHANGE_POPUP_VISIBILITY:
        case ActionType.CHANGE_MY_PROFILE_POPUP_VISIBILITY:
        case ActionType.CHANGE_MESSAGES_POPUP_VISIBILITY:
            return {
                ...state,
                isLoading: false,
                error: null,
                registrationError: {
                    message: null
                },
                profileError: {
                    message: null
                },
                success: null,
                profileSuccess: null
            }
        case ActionType.LOGIN_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isLoggedIn: true,
                email: action.payload.user.userName,
            }
        case ActionType.GET_SESSION_HISTORY_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ActionType.GET_SESSION_HISTORY_SUCCESS:
            return {
                ...state,
                isLoading: false
            }
        case ActionType.GET_SESSION_HISTORY_ERROR:
            return {
                ...state,
                isLoading: false
            }
        case ActionType.QUIT_SESSIONS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ActionType.QUIT_SESSIONS_SUCCESS:
            return {
                ...state,
                isLoading: false
            }
        case ActionType.QUIT_SESSIONS_ERROR:
            return {
                ...state,
                isLoading: false
            }
        case ActionType.CHANGE_LOGIN_STATE:
            return {
                ...state,
                isLoggedIn: action.payload
            }
        case ActionType.LOGIN_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
                isLoggedIn: false,
                email: action.payload.user.username,
                error: action.payload.error
            }
        case ActionType.REGISTER_USER_BEGIN:
            return {
                ...state,
                isLoading: true,
                isLoggedIn: false,
                registrationError: {
                    message: null
                }
            }

        case ActionType.REGISTER_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaving: false,
                registrationError: {
                    message: null
                }
            }
        case ActionType.REGISTER_USER_ERROR:
            return {
                ...state,
                isLoading: false,
                isSaving: false,
                isLoggedIn: false,
                registrationError: action.payload
            }
        case ActionType.SET_NOTIFICATION_PREFERENCES_BEGIN:
        case ActionType.CHECK_REGISTRATION_DATA_BEGIN:
        case ActionType.SET_LOADING_STATE:
        case ActionType.GET_TRANSACTION_INFO_BEGIN:
        case ActionType.GET_REFERRER_REPORT_BEGIN:
        case ActionType.GET_PAYMENT_REQUESTS_COMMISSIONS_BEGIN:
            return {
                ...state,
                isLoading: true,
                registrationError: {
                    message: null
                }
            }
        case ActionType.SET_NOTIFICATION_PREFERENCES_ERROR:
        case ActionType.SET_NOTIFICATION_PREFERENCES_SUCCESS:
        case ActionType.GET_NOTIFICATION_PREFERENCES_ERROR:
        case ActionType.GET_NOTIFICATION_PREFERENCES_RULES_ERROR:
        case ActionType.CHECK_REGISTRATION_DATA_SUCCESS:
        case ActionType.GET_TRANSACTION_INFO_ERROR:
        case ActionType.GET_PAYMENT_REQUESTS_COMMISSIONS_ERROR:
            return {
                ...state,
                isLoading: false
            }
        case ActionType.CHECK_REGISTRATION_DATA_ERROR:
            return {
                ...state,
                isLoading: false,
                registrationError: action.payload
            }
        case ActionType.CHECK_REGISTRATION_ERROR_RESET:
            return {
                ...state,
                registrationError: {
                    message: null
                }
            }
        case ActionType.EDIT_PROFILE_BEGIN:
            return {
                ...state,
                isSaving: true,
                profileError: {
                    message: null
                },
                profileSuccess: null
            }
        case ActionType.EDIT_PROFILE_ERROR:
            return {
                ...state,
                isSaving: false,
                profileError: action.payload
            }
        case ActionType.EDIT_PROFILE_SUCCESS:
            return {
                ...state,
                isSaving: false,
                profileSuccess: action.payload
            }

        // Document Upload
        case ActionType.UPLOAD_FILE_BEGIN:
            return {
                ...state,
                isUploading: true,
                documentError: {
                    message: null
                },
                documentSuccess: null
            }
        case ActionType.UPLOAD_FILE_SUCCESS:
            return {
                ...state,
                isUploading: false,
                documentSuccess: action.payload
            }
        case ActionType.GET_KYC_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ActionType.GET_KYC_ERROR:
            return {
                ...state,
                isLoading: false
            }
        case ActionType.GET_KYC_SUCCESS:
            return {
                ...state,
                kyc: action.payload,
                isLoading: false
            }
        case ActionType.SET_KYC_BEGIN:
            return {
                ...state,
                isUploading: true
            }
        case ActionType.SET_KYC_ERROR:
            return {
                ...state,
                isUploading: false
            }
        case ActionType.SET_KYC_SUCCESS:
            return {
                ...state,
                isUploading: false
            }
        case ActionType.UPLOAD_FILE_ERROR:
            return {
                ...state,
                isUploading: false,
                documentError: action.payload
            }

        case ActionType.GET_PLAYER_DOCUMENTS_STATES_BEGIN:
            return {
                ...state,
                isUploading: true,
                documentSuccess: null,
                documentStatesError: null
            }
        case ActionType.GET_PLAYER_DOCUMENTS_STATES_ERROR:
            return {
                ...state,
                isUploading: false,
                documentStatesError: action.payload,
                documentStates: []
            }
        case ActionType.GET_PLAYER_DOCUMENTS_STATES_SUCCESS:
            return {
                ...state,
                isUploading: false,
                documentStates: action.payload
            }
        // Get Deposit
        // Get DITHRAWALS
        // Get Tournaments
        // Get BetHistory
        // Get Balance
        case ActionType.GET_WITHDRAWALS_BEGIN:
        case ActionType.GET_DEPOSIT_BEGIN:
        case ActionType.GET_TOURNAMENTS_HISTORY_BEGIN:
        case ActionType.GET_BETS_HISTORY_BEGIN:
        case ActionType.GET_TRANSACTIONS_HISTORY_BY_TYPE_BEGIN:
            return {
                ...state,
                isLoading: true,
                result: []
            }
        case ActionType.GET_TOURNAMENTS_HISTORY_ERROR:
        case ActionType.GET_DEPOSIT_ERROR:
        case ActionType.GET_DITHRAWALS_ERROR:
        case ActionType.GET_BETS_HISTORY_ERROR:
        case ActionType.GET_REFERRER_REPORT_ERROR:
        case ActionType.GET_TRANSACTIONS_HISTORY_BY_TYPE_ERROR:
            return {
                ...state,
                isLoading: false,
                result: []
            }
        case ActionType.GET_DEPOSIT_SUCCESS:
        case ActionType.GET_DITHRAWALS_SUCCESS:
        case ActionType.GET_TOURNAMENTS_HISTORY_SUCCESS:
        case ActionType.GET_BETS_HISTORY_SUCCESS:
        case ActionType.GET_REFERRER_REPORT_SUCCESS:
        case ActionType.GET_TRANSACTIONS_HISTORY_BY_TYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                result: action.payload
            }
        case ActionType.GET_TRANSACTION_INFO_SUCCESS:
            const transactionId = Number(action.payload.id);
            return {
                ...state,
                isLoading: false,
                result: {
                    ...state.result,
                    transactionInfo: {
                        ...state.result.transactionInfo,
                        [transactionId]: action.payload.data
                    }
                }
            }
        case ActionType.GET_PAYMENT_REQUESTS_COMMISSIONS_SUCCESS:
            const commisionsId = Number(action.payload.id);
            return {
                ...state,
                isLoading: false,
                result: {
                    ...state.result,
                    commisionsInfo: {
                        ...state.result.transactionInfo,
                        [commisionsId]: action.payload.data
                    }
                }
            }
        case ActionType.CHECK_RUSSIAN_VERIFICATION_STATUS_BEGIN:
            return {
                ...state,
                isRussianLoading: true
            }
        case ActionType.CHECK_RUSSIAN_VERIFICATION_STATUS_ERROR:
            return {
                ...state,
                isRussianLoading: false
            }
        case ActionType.CHECK_RUSSIAN_VERIFICATION_STATUS_SUCCESS:
            return {
                ...state,
                russianStatus: action.payload.status,
                russianShowIdentificationForm: action.payload.showIdentificationForm,
                russianStatusMessage: action.payload.notificationText,
                isRussianLoading: false
            }
        case ActionType.CHECK_RUSSIAN_VERIFICATIONV2_STATUS_SUCCESS:
            return {
                ...state,
                russianStatus: action.payload.ShowIdentificationForm,
                russianStatusV2: action.payload.State,
                russianStatusMessage: action.payload.NotificationText,
                russianStatusAlternativMessage: action.payload.AlternativNotificationText,
                isRussianLoading: false
            }
        case ActionType.GET_SIMPLE_CUPIS_ESIA_BEGIN:
            return {
                ...state,
                isLoading: true,
            }
        case ActionType.GET_CUPIS_TINKOFF_BEGIN:
            return {
                ...state,
                isLoading: true,
            }
        case ActionType.GET_SIMPLE_CUPIS_ESIA_ERROR:
            return {
                ...state,
                isLoading: false,
            }
        case ActionType.GET_TINKOFF_ERROR:
            return {
                ...state,
                isLoading: false,
            }

        case ActionType.GET_CUPIS_TINKOFF_SUCCESS: {
            return {
                ...state,
                tinkoff: action.payload,
                isLoading: false
            }
        }
        case ActionType.GET_SIMPLE_CUPIS_ESIA_SUCCESS: {
            return {
                ...state,
                isLoading: false
            }
        }
        case ActionType.GET_CURRENCY_SPECEFIC_SETTINGS_SUCCESS: {
            return {
                ...state,
                currencySpeceficSettings: action.payload
            }
        }
        case ActionType.GET_NEW_PLATCURRENCY_SPECEFIC_SETTINGS_SUCCESS: {
            return {
                ...state,
                currencySpeceficSettings: [{ currencyId: action.payload, key: 'Report', digitsAfterPoint: 2 }, { currencyId: action.payload, key: 'FreeSpin', digitsAfterPoint: 2 }]
            }
        }
        case ActionType.CANCEL_WITHDRAWAL_BEGIN_NO_RESET:
            return {
                ...state,
                isCancelWithdrawalLoading: true,
            }
        case ActionType.CANCEL_WITHDRAWAL_BEGIN:
            return {
                ...state,
                isCancelWithdrawalLoading: true,
                result: []
            }
        case ActionType.CANCEL_WITHDRAWAL_ERROR:
            return {
                ...state,
                isCancelWithdrawalLoading: false,
                error: action.payload
            }
        case ActionType.CANCEL_WITHDRAWAL_SUCCESS:
            return {
                ...state,
                isCancelWithdrawalLoading: false
            }
        case ActionType.FORGOT_PASSWORD_RECOVERY_BEGIN:
        case ActionType.CHANGE_PASSWORD_BEGIN:
            return {
                ...state,
                forgotPassword: [],
                error: null,
                isSaving: true
            }
        case ActionType.FORGOT_PASSWORD_RECOVERY_SUCCESS:
        case ActionType.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPassword: action.payload,
                isSaving: false
            }
        case ActionType.FORGOT_PASSWORD_RECOVERY_ERROR:
        case ActionType.CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                error: action.payload,
                isSaving: false
            }
        case ActionType.RECOVER_PASSWORD_BEGIN:
            return {
                ...state,
                recoverPassword: []
            }
        case ActionType.RECOVER_PASSWORD_SUCCESS:
            return {
                ...state,
                recoverPassword: action.payload
            }
        case ActionType.RECOVER_USER_NAME_BEGIN:
        case ActionType.CONFIRM_REGISTRATION_VERIFICATION_CODE_BEGIN:
            return {
                ...state,
                isSaving: true
            }
        case ActionType.RECOVER_USER_NAME_SUCCESS:
        case ActionType.RECOVER_USER_NAME_ERROR:
        case ActionType.CONFIRM_REGISTRATION_VERIFICATION_CODE_ERROR:
            return {
                ...state,
                isSaving: false
            }
        case ActionType.USER_LOGOUT:
            Auth.invalidateSession();
            return {
                ...state,
                isLoggedIn: false,
                playerData: {},
                refreshTokenWaiting: false
            }
        case ActionType.GET_PLAYER_DATA_BEGIN:
            return {
                ...state,
                isSaving: false,
                error: {
                    errors: []
                },
                success: null
            }
        case ActionType.PLAYER_DATA_RESET:
            return {
                ...state,
                playerData: {}
            }
        case ActionType.RECOVER_PASSWORD_ERROR:
        case ActionType.GET_ACCOUNT_WALLETS_ERROR:
        case ActionType.GET_PLAYER_DATA_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case ActionType.GET_PLAYER_DATA_SUCCESS:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    player: action.payload
                }
            }
        case ActionType.GET_ACCOUNT_WALLETS_SUCCESS:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    accountBalance: {
                        ...state.playerData.accountBalance,
                        ...getWallets(action.payload)
                    }
                }
            }
        case ActionType.SET_PROMPT_LIMITS:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                   player:{
                    ...state.playerData.player,
                    promptLimits:{
                        ...state.playerData.player.promptLimits,
                        ...action.payload
                    }
                   }
                }
            }
        case ActionType.GET_PLAYER_BALANCE_BEGIN:
            return {
                ...state,
                isBalanceLoading: true
            }
        case ActionType.GET_PLAYER_BALANCE_ERROR:
            return {
                ...state,
                isBalanceLoading: false,
                balanceError: action.payload
            }
        case ActionType.GET_PLAYER_BALANCE_SUCCESS:
            return {
                ...state,
                isBalanceLoading: false,
                playerData: {
                    ...state.playerData,
                    accountBalance: {
                        ...state.playerData.accountBalance,
                        ...getBalances(action.payload, state)
                    }
                }
            }
        case ActionType.SET_PLAYER_SPORT_BONUS_BALANCE:
            return {
                ...state,
                sportBonusBalance: action.payload,
            }
        case ActionType.SET_PLAYER_SPORT_TOURNAMENTS_BALANCE:
            return {
                ...state,
                sportTournamentsBalance: action.payload,
            }
        case ActionType.REFRESH_TOKEN_BEGIN:
            return {
                ...state,
                refreshTokenWaiting: true
            }
        case ActionType.REFRESH_TOKEN_SUCCESS:
            return {
                ...state,
                refreshTokenWaiting: false
            }
        case ActionType.SET_REDIRECT_URL:
            return {
                ...state,
                redirectUrl: action.payload
            }
        case ActionType.CHANGE_PLAYER_DATA:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    player: {
                        ...state.playerData.player,
                        ...action.payload
                    }
                }
            }
        case ActionType.UNVERIFY_ACCOUNT_MOBILE:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    player: {
                        ...state.playerData.player,
                        isMobileNumberVerified: false
                    }
                }
            }
        case ActionType.UNVERIFY_DOCUMENT_NUMBER:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    player: {
                        ...state.playerData.player,
                        isDocumentVerified: false
                    }
                }
            }
        case ActionType.UNVERIFY_ACCOUNT_EMAIL:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    player: {
                        ...state.playerData.player,
                        isEmailVerified: false,
                        isEmailUpdated: true
                    }
                }
            }
        case ActionType.GET_INFO_BLOCK_SUCCESS:
            return {
                ...state,
                playerData: {
                    ...state.playerData,
                    userInfoData: action.payload
                }
            }
        case ActionType.SET_LANGUAGE:
            return {
                ...state,
                language: action.payload
            }

        case ActionType.REALITY_CHECK_POPUP_VISIBILITY:
            return {
                ...state,
                isRealityCheckPopupVisible: action.payload
            }
        case ActionType.SHOW_BALANCE:
            return {
                ...state,
                showBalanceState: action.payload
            }

        default:
            return state;
    }

}

